import { sliderConfig } from '../config/sliderConfigurations.js';

var sliderCartConfig = sliderConfig(7, true, '0', false, 1);
var sliderShopConfig = sliderConfig(3, true, '0', true, 2);
// update heights of images in the carousel
// Ajustement des flèches slick, sauf pour le bloc #primary-images

var loadedRecomSlot = [];

function deplaceArrows() {
  $('.recently-v-arrows .slick-prev').insertBefore('.title-arrows-rv');
  $('.recently-v-arrows .slick-next').insertAfter('.title-arrows-rv');
  $('.complet-set-arrows .slick-prev').insertBefore('.title-arrows-cs');
  $('.complet-set-arrows .slick-next').insertAfter('.title-arrows-cs');
}

function applySlider(elementId) {
  const container = $('#' + elementId).find(".custom-recommendations");
  const displayType = container.data('display');
  const config = displayType === 'cart' ? sliderCartConfig : sliderShopConfig;

  if (container.length) {
    container.slick(config);
    container.parents('.recommendations').removeClass("d-none");
    deplaceArrows();


    $(window).on('resize', function () {
      deplaceArrows();
    });
  }
}

function registerSliderEvents(target) {
  var observer = new WebKitMutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.target.id && mutation.target.id.startsWith("cq_recomm_slot-")) {

        if (loadedRecomSlot.indexOf(mutation.target.id) == -1) {
          loadedRecomSlot.push(mutation.target.id)
          setTimeout(function () {
            applySlider(mutation.target.id)
          }, 500);
        }
      }
    });
  });
  observer.observe(target, {
    attributes: true,
    childList: true,
    characterData: true,
    subtree: true
  });
}

var targets = document.querySelectorAll('[id^="cq_recomm_slot-"]');

for (var i = 0; i < targets.length; i++) {
  registerSliderEvents(targets[i])
}


$('.slider-recommendations-shop').parents('.shop-the-look-reco').removeClass("d-none");
$(".slider-recommendations-shop").slick(sliderShopConfig);

$('.slider-recommendations-cart').parents('.shop-the-look-reco').removeClass("d-none");
$('.slider-recommendations-cart').parents('.recommendations').removeClass("d-none");
$(".slider-recommendations-cart").slick(sliderCartConfig);

$('.shop-reco .slick-prev').insertBefore('.title-arrows-shop');
$('.shop-reco .slick-next').insertAfter('.title-arrows-shop');
